export default {"src":"/_next/static/media/planet_fitness.e0b9bdfc.svg","height":41,"width":40};